import { VueConstructor } from 'vue';
import Permission from './vue-permission.directive';
import CountRunning from './vue-count-running.directive';

export default function install(Vue: VueConstructor) {
  Vue.directive('permission', Permission); // 按钮权限控制
  Vue.directive('countRunning', CountRunning); // 按钮权限控制
}
